import React, { Component } from 'react';
import { Modal, Button, Form, InputNumber } from 'antd';
import Request from 'superagent';
import NotificationManager from '../../commons/CustomNotificationManager.js';

const FormItem = Form.Item;

class ServiceScaleForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            saving: false,
            service: {},
            canSave: false,
            origin: 0
        }
    }

    close = () => {
        this.setState({
            showModal: false,
            saving: false,
            service: {},
            canSave: false,
            origin: 0
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.service && nextProps.service.serviceName !== this.state.service.serviceName) {
            this.props.form.resetFields();
            this.setState({
                showModal: nextProps.show,
                service: nextProps.service,
                origin: nextProps.service.instances.length
            })
        }
    }

    save = () => {
        this.props.form.validateFields((err, obj) => {
            const currentVersion = this.state.service.serviceVersion.substr(1);
            const newService = {
                serviceName: this.state.service.serviceName,
                serviceVersion: currentVersion,
                count: obj.count
            };
            this.setState({saving: true});
            Request.post('/scaler/setScale').withCredentials()
                .set('Accept', 'application/json')
                .send(newService)
                .end((error, response) => {
                    this.setState({saving: false});
                    if (error) {
                        console.error(error);
                        if (error.status === 409) {
                            NotificationManager.error('Duplicate company name or email address.');
                        } else {
                            NotificationManager.error('Failed to scale service.');
                        }
                    } else {
                        this.props.onSuccess();
                        NotificationManager.success('Succeed to scale service. Please wait for service starting. After service starts, service status can be checked on System Usage.');
                        this.close();
                    }
                });
        });
    }

    checkCount = (value) => {
        if (value < 1 || value > 100 || value === this.state.origin) {
            this.setState({canSave: false});
        } else {
            this.setState({canSave: true});
        }
    }

    render() {
        const { saving, service, canSave, showModal, origin } = this.state;
        const title = "Scale Service " + service.serviceName;
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16}
            }
        };
        return (
            <div>
                <Modal visible={showModal} title={title}
                       closable={ false } maskClosable={false} style={{ top: 70 }}
                       footer={[
                        <Button key="submit" type="primary" size="large" loading={saving} disabled={!canSave} onClick={this.save}>Save</Button>,
                        <Button key="back" size="large" disabled={saving} onClick={this.close}>Cancel</Button>
                    ]}>
                    <div>
                        <Form>
                            <FormItem {...formItemLayout} label="Service Count">
                                {getFieldDecorator('count', {
                                    initialValue: origin,
                                    rules: [{required: true, message: "Required"}]
                                })(
                                    <InputNumber min={1} max={100} onChange={this.checkCount}/>
                                )}
                                <span className="ant-form-text"> (1 - 100)</span>
                            </FormItem>
                        </Form>
                    </div>
                </Modal>
            </div>
        );
    }
}

const ServiceScale = Form.create()(ServiceScaleForm);
export default ServiceScale;


// WEBPACK FOOTER //
// ./src/modules/multi-tenanted-service/ServiceScale.js